class PopupLink {
    constructor(blockEl) {
        this.block = blockEl;
        if (!this.block) return;

        // Makes the entire widget block the clickable area.
        this.clickableArea = this.block; 

        // Attaches the click event to the entire widget area.
        this.onTextClick = this.onTextClick.bind(this);
        this.clickableArea.addEventListener('click', this.onTextClick);
    }

    onTextClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.open();
    }

    open() {
        let appStoreUrl;

        // Detection for ALL Apple devices (iPhone, iPad, iPod, and Macintosh/Mac)
        const isAppleDevice = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);

        if (isAppleDevice) {
            // Apple App Store URL 
            appStoreUrl = 'https://apps.apple.com/us/app/the-fridge-mobile-app/id6746397857'; 
        } else {
            // Default to Google Play Store (for Android, Windows, or other non-Apple systems).
            appStoreUrl = 'https://play.google.com/store/apps/details?id=com.TheFridge.android';
        }

        window.open(
            appStoreUrl,
            '_blank' 
        );
    }
}

export default PopupLink;